import { useForm } from '@mantine/form';
import { ReactNode } from 'react';

import { SIMULATION_STATUSES } from '../../config';
import { SimulationFormProvider } from '../../hooks';
import { FormValues, statusFormConfig } from '../../utils';

interface FormProviderProps {
  children: ReactNode;
  status: SIMULATION_STATUSES;
}

export const FormProvider = ({ children, status }: FormProviderProps) => {
  const currentFormConfig = statusFormConfig[status];
  const formConfig = currentFormConfig?.formConfig || { initialValues: {} };

  const form = useForm<FormValues>(formConfig);

  const value = {
    form,
    currentFormConfig,
    hasForm: !!currentFormConfig,
  };

  return <SimulationFormProvider value={value}>{children}</SimulationFormProvider>;
};
